<template>
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="120px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="收款人:" prop="payee">
                <el-input  placeholder="" v-model="searchFrom.payee"></el-input>
              </el-form-item>

             <el-form-item label="个税上报状态:" prop="taxReportStatus">
                <el-select  v-model="searchFrom.taxReportStatus"   placeholder="请选择">
                  <el-option label="未上报" value="1"></el-option>
                  <el-option label="已上报" value="2"></el-option>
                  <el-option label="上报失败" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="其他税上报状态:" prop="surtaxReportStatus">
                <el-select  v-model="searchFrom.surtaxReportStatus"   placeholder="请选择">
                  <el-option label="未上报" value="1"></el-option>
                  <el-option label="已上报" value="2"></el-option>
                  <el-option label="上报失败" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年月:" prop="taxDate">
               <el-date-picker
                      v-model="searchFrom.taxDate"
                      :editable="false"
                      :clearable="false"
                      type="month"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      placeholder="选择月">
              </el-date-picker>
              </el-form-item>
              <el-form-item label="个税上报日期:" prop="taxReportDates">
                <el-date-picker
                  v-model="searchFrom.taxReportDates"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
               <el-form-item label="其他税上报日期:" prop="surtaxReportDates">
                <el-date-picker
                  v-model="searchFrom.surtaxReportDates"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
        <div style="display: flex;justify-content: space-between;">
            <div>
          <el-form-item btnCode="00JP009B001" >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
           <el-form-item v-if="btnFlg[0]">
            <el-button type="primary" @click="gssbFN">个税上报</el-button>
          </el-form-item>
          <el-form-item v-if="btnFlg[1]">
            <el-button type="primary" @click="qtssbFN">其他税上报</el-button>
          </el-form-item>
          <el-form-item v-if="btnFlg[2]">
            <el-button type="primary" @click="gshzFN">个税汇总上报</el-button>
          </el-form-item>
           <el-form-item v-if="btnFlg[3]">
            <el-button type="primary" :disabled="isDisable" @click="daochuFN">导出</el-button>
          </el-form-item>
          <el-form-item v-if="btnFlg[4]" >
            <el-button type="primary" @click="tuisongFn">15万上报</el-button>
          </el-form-item>
           <el-form-item v-if="btnFlg[5]">
            <el-button type="primary" @click="LINreportFN">临时纳税人上报</el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item v-if="btnFlg[6]">
            <el-button type="text" @click=" reportFn">临时纳税人上报记录</el-button>
          </el-form-item>
        </div>
        </div>

       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
         <el-table-column property="payee" width="200"  :formatter="emptyFn"   label="收款人"></el-table-column>
          <el-table-column property="taxReportStatus" label="个税上报状态" width="120">
            <template scope="scope">{{[ "未上报", "已上报","上报失败"][scope.row.taxReportStatus-1]}}</template>
          </el-table-column>
        <el-table-column property="surtaxReportStatus" label="其他税上报状态" width="120">
            <template scope="scope">{{[ "未上报", "已上报","上报失败"][scope.row.surtaxReportStatus-1]}}</template>
          </el-table-column>
        <el-table-column property="taxDate"  width="120"  :formatter="emptyFn"   label="年月"> </el-table-column>
        <el-table-column property="fatePrice"  width="120"  :formatter="emptyFn"   label="月收入"> </el-table-column>
        <el-table-column property="taxableIncome"  width="200"  :formatter="emptyFn"   label="应税收入"></el-table-column>
        <el-table-column property="taxBasis"  width="150"  :formatter="emptyFn"   label="计税依据"></el-table-column>
        <el-table-column property="taxPayable"  width="120"  :formatter="emptyFn"   label="应纳税额"></el-table-column>
        <el-table-column property="taxRate"  width="120"  :formatter="emptyFn"   label="税率(速算表)"></el-table-column>
        <el-table-column property="quickCalculationDeduction"  width="120"  :formatter="emptyFn"   label="速算扣除数"></el-table-column>
        <el-table-column width="170" property="accumulatedTaxPaid" :formatter="emptyFn" label="累计已缴税额"></el-table-column>

         <el-table-column property="taxReimbursement"  width="120"  :formatter="emptyFn"   label="本期应补退税额"></el-table-column>
        <el-table-column property="stampDuty"  width="120"  :formatter="emptyFn"   label="印花税"></el-table-column>
        <el-table-column property="valueAddedTax"  width="120"  :formatter="emptyFn"   label="增值税应纳税额"></el-table-column>
        <el-table-column property="vatDeduction"  width="120"  :formatter="emptyFn"   label="增值税减免税额"></el-table-column>
        <el-table-column property="addedTax"  width="120"  :formatter="emptyFn"   label="增值税"></el-table-column>
        <el-table-column width="170" property="urbanConstructionTax" :formatter="emptyFn" label="城建税"></el-table-column>
        <el-table-column property="educationSurtax"  width="120"  :formatter="emptyFn"   label="教育费附加"></el-table-column>
        <el-table-column width="170" property="localEducationSurtax" :formatter="emptyFn" label="地方教育费附加"></el-table-column>
         <el-table-column property="createUserName"  width="120"  :formatter="emptyFn"   label="上报人"></el-table-column>
        <el-table-column width="170" property="taxReportDate" :formatter="dateTimeFormat" label="个税上报日期"></el-table-column>
         <el-table-column width="170" property="surtaxReportDate" :formatter="dateTimeFormat" label="其他税上报日期"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <!-- 个税上报汇总 -->
    <el-dialog  :title="HZfrom.taxDate+' 结算明细'"  :visible.sync="dialogHZ" width="500px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="HZfrom" ref="HZfrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="inpBox">
          <div style="text-align: center;">
            <el-form-item prop="" label="上报人数:">
              <div class="fontStyle">
                 {{HZfrom.sbrs}}
              </div>
            </el-form-item>
            <el-form-item label="税率:"  class="jiage" prop="">
              <span class="fontStyle">{{HZfrom.sl}}</span>
            </el-form-item>
              <!-- <el-table :data="HZfrom.tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
                <el-table-column type="index"  prop="date" width="55" label="序号"></el-table-column>
                <el-table-column property="taxRate"  width="120"  :formatter="emptyFn"   label="税率(%)"></el-table-column>
                <el-table-column property="taxRate"  width="120"  :formatter="emptyFn"   label="申报人数"></el-table-column>
                <el-table-column property="taxableIncome"  width="120"  :formatter="emptyFn"   label="应税收入"></el-table-column>
                <el-table-column property="taxPayable"  width="120"  :formatter="emptyFn"   label="应纳税额"></el-table-column>
                <el-table-column property="taxableIncome"  width="120"  :formatter="emptyFn"   label="累计已缴纳税额"></el-table-column>
                <el-table-column property="taxableIncome"  min-width="120"  :formatter="emptyFn"   label="本期应补退税额"></el-table-column>
              </el-table> -->
          </div>
           <el-divider></el-divider>
          <div style="text-align: center;">
            <el-form-item label="应税收入合计:"  class="jiage" prop="">
               <div><span class="fontStyle">{{HZfrom.yssr}}</span>元</div>
            </el-form-item>
          </div>
          <div style="text-align: center;">
            <el-form-item label="应纳税额合计:"  class="jiage" prop="">
              <div><span class="fontStyle">{{HZfrom.ynse}}</span>元</div>
            </el-form-item>
          </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogHZ = false">关闭</el-button>
        <el-button type="primary" @click="HZsave">确定上报</el-button>
      </span>
   </el-dialog>
     <el-dialog :title="title"  :visible.sync="SQMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="145px" size="mini">
        <div class="inpBox1">
            <div style="margin: 28px 0;">
              <!-- <el-form-item label="年月:" prop="taxDate" class="inpBox2">
                <el-date-picker
                  v-model="SQFrom.taxDate"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  placeholder="选择日期"
                ></el-date-picker>
            </el-form-item> -->
             <el-form-item label="年月:" prop="taxDate">
               <el-date-picker
                      v-model="SQFrom.taxDate"
                      :editable="false"
                      :clearable="false"
                      type="month"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      placeholder="请选择年月">
              </el-date-picker>
              </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()">确定</el-button>
      </span>
   </el-dialog>
   <!-- 上报 -->
    <el-dialog title="提示"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="reportMark"
    width="400px"
    center>
      <div>
        <span style="text-align: center;display:block;margin:40px 0">确认上报临时纳税人信息吗?</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reportMark = false">取 消</el-button>
        <el-button type="primary" @click="recallSave">确 定</el-button>
      </span>
    </el-dialog>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import {
  sTaxationSummaryList, // 列表
  reportTax, // 个税上报
  statisticsTaxSummary,
  reportTaxSummary, // 个税汇总上报
  reportSurtaxSummary, // 其他税上报
  reportTemporaryTaxpayerInfo,
  reportingTemporaryTax
} from '@/api/consignment'
export default {
  data () {
    return {
      reportMark: false,
      recallId: '',
      title: '',
      SQFrom: {},
      SQMark: false,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: false,
      total: 0,
      rules: {
        reason: { required: true, message: '请输入拒绝原因', trigger: 'blur' },
        taxDate: { required: true, message: '请选择年月', trigger: 'blur' }
      },
      dialogHZ: false,
      HZfrom: {},
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['00JP00LB001', '00JP00LB002', '00JP00LB003', '00JP00LB004', '00JM0Y0100', '00JM0Y0200', '00JM0Y0300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/paymenWithholding/taxDeclaration')
    this.$set(this.searchFrom, 'taxDate', this.getLastMonth())
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 上报记录
    reportFn (row) {
      this.$router.push({ name: 'paymenWithholdingIdentityRport' })
    },
    LINreportFN (row) {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        selectData.some((item, index) => {
          console.log(item)
          this.ids.push(item.id)
          console.log(this.ids)
          this.$set(this, 'recallId', this.ids)
          this.reportMark = true
        })
      }
    },
    recallSave () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      reportingTemporaryTax(this.recallId).then(res => {
        loading.close()
        this.$message({
          message: '上报成功',
          type: 'success'
        })
        this.reportMark = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    tuisongFn () {
      this.SQMark = true
      this.title = '15万上报'
    },
    SQsave () {
      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          reportTemporaryTaxpayerInfo(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 获取年月
    getLastMonth () { // 获取上个月日期
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()
      if (month == 0) {
        year = year - 1
        month = 12
      }
      return year + '-' + month
    },
    // 导出
    daochuFN () {
      exportExcel(
        this.global.payName + '/sTaxationSummary/exportSTaxationSummaryExcel',
        { taxDate: this.searchFrom.taxDate },
        this.searchFrom.taxDate + '税费导出——'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 个税汇总上报
    gshzFN () {
      statisticsTaxSummary().then(res => {
        this.HZfrom = res
        this.dialogHZ = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    HZsave () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      reportTaxSummary(this.HZfrom).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.dialogHZ = true
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }

        })
      })
    },
    gssbFN () {
      this.$confirm('是进行' + this.getLastMonth() + '的个税上报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        reportTax().then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }

          })
        })
      }).catch(() => {

      })
    },
    qtssbFN () {
      this.$confirm('是进行' + this.getLastMonth() + '的其他税上报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        reportSurtaxSummary().then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sTaxationSummaryList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    // 获取年月
    getLastMonth () { // 获取上个月日期
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()
      if (month == 0) {
        year = year - 1
        month = 12
      }
      return year + '-' + month
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        taxDate: this.getLastMonth()
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
.fontStyle{
  font-size: 20px;
  color: red;
}
/deep/.el-divider--horizontal{
  margin-top: 14px;
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
